// Common input errors.
enum InputError {
    Required = "Required",
    Invalid = "Invalid",
}

export default InputError;
